<template>
  <!-- Only en for now, not sure we will follow the fr thing -->
  <TextField
    id="mealplan-note"
    :name="`${formNamespace}note.en`"
    :label="translate(`${LOCALE_PREFIX}.form.additionalInstructions`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.additionalInstructionsPlaceholder`)"
    :disabled="!editMealPlan"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../../enums';
import { useFinancialConfigStore } from '../../../../../../routes';
import { inject } from 'vue';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

const formNamespace = inject('formNamespace', '');
</script>
